import { render, staticRenderFns } from "./DesktopSettings.vue?vue&type=template&id=884f750c&scoped=true"
import script from "./DesktopSettings.vue?vue&type=script&lang=js"
export * from "./DesktopSettings.vue?vue&type=script&lang=js"
import style0 from "./DesktopSettings.vue?vue&type=style&index=0&id=884f750c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884f750c",
  null
  
)

export default component.exports